import { apiFetch } from './api';

export type PaidTier = 'pro' | 'scale';

/**
 * Kick off a hosted Stripe Checkout for `tier`. On success, navigates the
 * browser to Stripe's URL — we don't return because the page is replaced.
 *
 * The caller is responsible for catching errors and surfacing them inline.
 */
export async function startCheckout(tier: PaidTier): Promise<never> {
  const { url } = await apiFetch<{ url: string }>('/api/billing/checkout', {
    method: 'POST',
    json: { tier },
  });
  window.location.href = url;
  // The redirect race means we never actually return; the never type matches.
  return new Promise<never>(() => {});
}

/**
 * Open the Stripe Customer Billing Portal (manage payment method, cancel,
 * view invoices). User must already have a Stripe customer — call only when
 * `session.user.hasBillingCustomer` is true.
 */
export async function openBillingPortal(): Promise<never> {
  const { url } = await apiFetch<{ url: string }>('/api/billing/portal', {
    method: 'POST',
  });
  window.location.href = url;
  return new Promise<never>(() => {});
}
